module.exports = __webpack_public_path__ + "img/angular-stencil.a8c5bed5.svg";